<template>
  <div class="calendar-container">
    <div class="calendar-filters my-5">
      <div class="calendar-filters--item"
        ref="roleDropdown">
        <div @click.prevent="() => {
          showRoleList = !showRoleList;
          showGeosList = false;
          showPersonList = false;
          showProjectsList = false;
        }"
          class="calendar-filters--item__title"
          :style="[
            !filterRole ? { 'border': 'none' } : {}
          ]">
          <v-icon class="calendar-filters--item__title--icon" color="#697A9B">mdi-circle-slice-8</v-icon>
          <p class="calendar-filters--item__title--text">Role</p>
        </div>
        <div v-if="filterRole"
          @click.prevent="() => {
            showRoleList = !showRoleList;
            showGeosList = false;
            showPersonList = false;
            showProjectsList = false;
          }"
          class="calendar-filters--item__value">
          <p>{{ filterRole }}</p>
        </div>
        <div v-if="filterRole"
          @click.prevent="clearRoleFilter"
          class="calendar-filters--item__remove">
          <v-icon class="calendar-filters--item__remove--icon" color="#697A9B">mdi-close</v-icon>
        </div>
        <div v-if="showRoleList"
          class="calendar-filters--item__dropdown" 
          style="background-color: #fff; width: 170px;">
          <ul class="dropdown-list">
            <li v-for="(item, index) in rolesListToShow" 
              :key="index"
              @click.prevent="setRoleFilter(item)"
              class="dropdown-list--item dropdown-list--item--role">
              <p class="dropdown-list--item__name">
                {{ item }}
              </p>
              <div class="dropdown-list--item__icon"
                v-if="filterRole === item">
                <v-icon class="dropdown-list--item__icon--check" color="#6E6E6E">mdi-check</v-icon>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="calendar-filters--item"
        ref="geoDropdown">
        <div @click.prevent="() => {
          showGeosList = !showGeosList;
          showRoleList = false;
          showPersonList = false;
          showProjectsList = false;
        }"
          class="calendar-filters--item__title"
          :style="[
            !filterGeo ? { 'border': 'none' } : {}
          ]">
          <v-icon class="calendar-filters--item__title--icon" color="#697A9B">mdi-earth</v-icon>
          <p class="calendar-filters--item__title--text">GEO</p>
        </div>
        <div v-if="filterGeo"
          @click.prevent="() => {
            showGeosList = !showGeosList;
            showRoleList = false;
            showPersonList = false;
            showProjectsList = false;
          }"
          class="calendar-filters--item__value">
          <p>{{ filterGeo }}</p>
        </div>
        <div v-if="filterGeo"
          @click.prevent="clearGeosFilter"
          class="calendar-filters--item__remove">
          <v-icon class="calendar-filters--item__remove--icon" color="#697A9B">mdi-close</v-icon>
        </div>
        <div v-if="showGeosList"
          class="calendar-filters--item__dropdown"
          style="background-color: #fff;">
          <div class="dropdown-input--container">
            <input type="text"
              placeholder="Search..."
              class="dropdown-input"
              v-model="geoInputFilter">
            <v-icon class="dropdown-input--clear" 
              color="#697A9B"
              v-if="geoInputFilter"
              @click.prevent.stop="geoInputFilter = ''">
              mdi-close
            </v-icon>
          </div>
          <ul class="dropdown-list">
            <li v-for="(item, index) in geosListToShow" 
              :key="index"
              @click.prevent="setGeoFilter(item)"
              class="dropdown-list--item dropdown-list--item--geo ">
              <p class="dropdown-list--item__name">
                {{ item }}
              </p>
              <div class="dropdown-list--item__icon"
                v-if="filterGeo === item">
                <v-icon class="dropdown-list--item__icon--check" color="#6E6E6E">mdi-check</v-icon>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="calendar-filters--item"
        ref="projectDropdown">
        <div class="calendar-filters--item__title"
          @click.prevent="() => {
            showProjectsList = !showProjectsList;
            showPersonList = false;
            showRoleList = false;
            showGeosList = false;
          }"
          :style="[
            !filterProject ? { 'border': 'none' } : {}
          ]">
          <v-icon class="calendar-filters--item__title--icon font-size--18px" color="#697A9B">mdi-book</v-icon>
          <p class="calendar-filters--item__title--text">Project</p>
        </div>
        <div v-if="filterProject"
          @click.prevent="() => {
            showProjectsList = !showProjectsList;
            showPersonList = false;
            showRoleList = false;
            showGeosList = false;
          }"
          class="calendar-filters--item__value">
          <p>{{ filterProject.name }}</p>
        </div>
        <div v-if="filterProject"
          class="calendar-filters--item__remove"
          @click.prevent="clearProjectFilter">
          <v-icon class="calendar-filters--item__remove--icon" color="#697A9B">mdi-close</v-icon>
        </div>
        <div v-if="showProjectsList"
          class="calendar-filters--item__dropdown"
          style="background-color: #fff;">
          <div class="dropdown-input--container">
            <input type="text"
              placeholder="Search..."
              class="dropdown-input"
              v-model="projectInputFilter">
              <v-icon class="dropdown-input--clear" 
                color="#697A9B"
                v-if="projectInputFilter"
                @click.prevent.stop="projectInputFilter = ''">
                mdi-close
              </v-icon>
          </div>
          <ul class="dropdown-list">
            <li v-for="(item, index) in projectListToShow" 
              :key="index"
              @click.prevent="setProjectFilter(item)"
              class="dropdown-list--item dropdown-list--item--project">
              <p class="dropdown-list--item__name">
                {{ item.name }}
              </p>
              <div class="dropdown-list--item__icon"
                v-if="filterProject && filterProject.name === item.name">
                <v-icon class="dropdown-list--item__icon--check" color="#6E6E6E">mdi-check</v-icon>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="calendar-filters--item"
        ref="personDropdown">
        <div @click.prevent="() => {
          showPersonList = !showPersonList;
          showProjectsList = false;
          showRoleList = false;
          showGeosList = false;
        }"
          class="calendar-filters--item__title"
          :style="[
            !filterPersons.length ? { 'border': 'none' } : {}
          ]">
          <v-icon class="calendar-filters--item__title--icon font-size--18px" color="#697A9B">mdi-account</v-icon>
          <p class="calendar-filters--item__title--text">Person</p>
        </div>
        <div v-if="filterPersons.length"
          @click.prevent="() => {
            showPersonList = !showPersonList;
            showProjectsList = false;
            showRoleList = false;
            showGeosList = false;
          }"
          class="calendar-filters--item__value px-2">
            <div class="calendar-filters--item__value__initials"
              :style="{
                'background-color': filterPersons[0].color,
                'display': 'flex',
                'align-items': 'center',
                'justify-content': 'center'
                }">
              {{ filterPersons[0].initials }}
            </div>
            <p class="calendar-filters--item__value__name pa-0">
              {{ filterPersons[0].name }} {{ filterPersons.length > 1 ? ', + ' + (filterPersons.length - 1) : '' }}
            </p>
        </div>
        <div v-if="filterPersons.length"
          @click.prevent="clearPersonsFilter"
          class="calendar-filters--item__remove">
          <v-icon class="calendar-filters--item__remove--icon" color="#697A9B">mdi-close</v-icon>
        </div>
        <div v-if="showPersonList"
          class="calendar-filters--item__dropdown"
          style="background-color: #fff;">
          <div class="dropdown-input--container">
            <input type="text"
              placeholder="Search..."
              class="dropdown-input"
              v-model="personInputFilter">
            <v-icon class="dropdown-input--clear" 
              color="#697A9B"
              v-if="personInputFilter"
              @click.prevent.stop="personInputFilter = ''">
              mdi-close
            </v-icon>
          </div>
          <ul class="dropdown-list">
            <li v-for="(item, index) in personsListToShow" 
              :key="index"
              @click.prevent="addPersonToFilterList(item)"
              class="dropdown-list--item dropdown-list--item-person">
              <div class="dropdown-list--item__initials"
                :style="{
                  'background-color': item.color,
                  'display': 'flex',
                  'align-items': 'center',
                  'justify-content': 'center'
                  }">
                {{ item.initials }}
              </div>
              <p class="dropdown-list--item__name">
                {{ item.name }}
              </p>
              <div class="dropdown-list--item__icon"
                v-if="filterPersons.some(p => p.id === item.id)">
                <v-icon class="dropdown-list--item__icon--check" color="#6E6E6E">mdi-check</v-icon>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="calendar elevation-3">
      <v-sheet tile height="56" class="d-flex justify-space-between align-center">
        <div class="control">
          <div class="control__month">
            <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <p class="current-page">{{ calendarTitle }}</p>
            <v-btn icon class="ma-2 control-icon" @click="$refs.calendar.next()">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
          <div class="control__toggler">
            <button
              class="control__toggler--btn"
              :class="{ 'control__toggler--btn--active': calendarVariant === 'availability' }"
              @click.prevent="changeCalendarView('availability')">
              AVAILABILITY
            </button>
            <button
              class="control__toggler--btn"
              :class="{ 'control__toggler--btn--active': calendarVariant === 'workload' }"
              @click.prevent="changeCalendarView('workload')">
              WORKLOAD
            </button>
          </div>
          <div class="control__left--workload"
            v-if="calendarVariant === 'workload'">
            <label for="workload">Workload type</label>
            <select
              v-model="workload"
              class="control__left--workload--select"
            >
              <option 
                v-for="option in workloadOptionsList"
                :key="option"
                :value="option">
                {{ option }}
              </option>
            </select>
          </div>
          <div class="control__calendarView"
            v-if="calendarVariant === 'workload'">
            <p class="control__calendarView--text">Calendar view:</p>
            <button
              class="control__calendarView--btn"
              :class="{ 'control__calendarView--btn--active': workloadView === 0 }"
              @click.prevent="changeWorkloadView(0)"
              >
              WEEK
            </button>
            <button
              class="control__calendarView--btn"
              :class="{ 'control__calendarView--btn--active': workloadView === 1 }"
              style="border-top-right-radius: 8px; border-bottom-right-radius: 8px; margin-left: 0;"
              @click.prevent="changeWorkloadView(1)"
              >
              DAY
            </button>
          </div>
          <div class="control__calendarView"
            v-else>
            <p class="control__calendarView--text">Calendar view:</p>
            <button
              class="control__calendarView--btn"
              :class="{ 'control__calendarView--btn--active': view === 0 }"
              @click.prevent="changeView(0)"
              >
              MONTH
            </button>
            <button
              class="control__calendarView--btn"
              :class="{ 'control__calendarView--btn--active': view === 1 }"
              @click.prevent="changeView(1)"
              >
              WEEK
            </button>
            <button
              class="control__calendarView--btn"
              :class="{ 'control__calendarView--btn--active': view === 2 }"
              @click.prevent="changeView(2)"
              >
              DAY
            </button>
          </div>
          <div class="control__jumpTo">
            <p class="control__jumpTo--text">Jump to:</p>
            <button
              class="control__jumpTo--btn"
              @click="focus = ''"
              >
              Today
            </button>
            <v-menu
              v-model="focusMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="control__jumpTo--btn"
                  v-bind="attrs"
                  v-on="on"
                  >
                  Select Date
                </button>
              </template>
              <v-date-picker
                v-model="focus"
                @input="focusMenu = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
      </v-sheet>
      <v-sheet max-height="700px" 
        class="overflow-y-auto overflow-x-hidden pb-14"
        v-if="calendarVariant === 'availability'">
        <v-skeleton-loader
          v-if="showCalendarLoader || employeesLoading"
          type="table-tbody@2"
        ></v-skeleton-loader>
        <v-calendar
          v-if="!showCalendarLoader && !employeesLoading"
          ref="calendar"
          class="admin-calendar"
          :class="{ disabled: mutableMode }"
          v-model="focus"
          :weekdays="[1, 2, 3, 4, 5, 6, 0]"
          :type="viewType"
          :event-more="false"
          :event-height="16"
          :events="filteredEvents"
          @change="getCurrentPage($event)"
          @click:date="profileView ? null : markUnavailable($event)"
          @click:event="profileView ? null : editUnavailabilityRecord($event)"
        ></v-calendar>
      </v-sheet>
      <v-sheet max-height="700px" 
        class="overflow-y-auto overflow-x-hidden pb-14 relative" v-else>
        <v-skeleton-loader
          v-if="showCalendarLoader || employeesLoading"
          type="table-tbody@2"
        ></v-skeleton-loader>
        <p v-if="!showCalendarLoader && !employeesLoading && !Object.keys(usersActivityData).length"
          class="workload-calendar__empty">Please Select User</p>
        <div class="workload-calendar">
          <v-calendar
            v-if="!showCalendarLoader && !employeesLoading"
            ref="calendar"
            class="admin-calendar workload-calendar__calendar"
            :class="{ disabled: mutableMode }"
            v-model="focus"
            :weekdays="[1, 2, 3, 4, 5, 6, 0]"
            :type="workloadViewType"
            :hide-header="false"
            :interval-count="0"
            :interval-height="60"
            :interval-width="0"
          ></v-calendar>
          <ul class="workload-calendar__data">
            <li
              class="workload-calendar__data--item"
              v-for="(item, index) in dataListforWorkload"
              :key="index"
            >
              <div class="workload-calendar__data--item__title">
                <div class="abreviation"
                  :style="{ 'background-color': item.color }">
                  {{ item.abreviation }}
                </div>
                <div class="name">{{ item.name }}</div>
              </div>
              <div class="workload-calendar__data--item__table">
                <div class="table--item"
                  :style="{ 'width': `${100 / item.data.length}%` }"
                  v-for="(userLimits, index) in item.data" 
                  :key="index">
                  <div class="custom-day">
                    <v-tooltip bottom color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <div class="custom-day__empty" 
                          v-bind="attrs" 
                          v-on="on" 
                          :style="`background-color: ${workload.includes('Copywriting') ? '#EED9FF' : '#D6E6FF'} `"
                          v-if="getWorkloadDataByDate(userLimits).limit === 0 && getWorkloadDataByDate(userLimits).limitOnDate">
                        </div>
                        <div class="custom-day__checkmark" 
                          v-bind="attrs" 
                          v-on="on" 
                          :style="`background-color: ${workload.includes('Copywriting') ? '#C57FFF' : '#0266E3'};`"
                          v-else-if="getWorkloadDataByDate(userLimits).limit / getWorkloadDataByDate(userLimits).limitOnDate > 0.9 
                            && getWorkloadDataByDate(userLimits).limit / getWorkloadDataByDate(userLimits).limitOnDate < 1.05">
                          <v-icon color="white">mdi-check</v-icon>
                        </div>
                        <div class="custom-day__exclamation" 
                          v-bind="attrs"
                          v-on="on" 
                          v-else-if="getWorkloadDataByDate(userLimits).limit / getWorkloadDataByDate(userLimits).limitOnDate >= 1.05">
                          !
                        </div>
                        <div class="custom-day__close"
                          v-bind="attrs" 
                          v-on="on" 
                          v-else-if="getWorkloadDataByDate(userLimits).limitOnDate === 0">
                          <v-icon color="#999999">mdi-close</v-icon>
                        </div>
                        <div class="custom-day__dot"
                          v-else
                          v-bind="attrs" 
                          v-on="on" 
                          :style="`background-color: ${workload.includes('Copywriting') ? '#EED9FF' : '#D6E6FF'} `">
                          <div
                            class="custom-day__dot--inner"
                            :style="`
                              margin: auto;
                              border-radius: 50%;
                              width: ${Math.max(0, Math.min(1, getWorkloadDataByDate(userLimits)?.limit / getWorkloadDataByDate(userLimits)?.limitOnDate)) * 30 + 10}px;
                              height: ${Math.max(0, Math.min(1, getWorkloadDataByDate(userLimits)?.limit / getWorkloadDataByDate(userLimits)?.limitOnDate)) * 30 + 10}px;
                              background-color: ${workload.includes('Copywriting') ? '#C57FFF' : '#0266E3'} `"
                          />
                        </div>
                      </template>
                      <div class="tooltip">
                        <p class="tooltip__text mb-0">Available workload: {{ getWorkloadDataByDate(userLimits).limitOnDate - getWorkloadDataByDate(userLimits).limit }} words</p>
                      </div>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </v-sheet>
      <v-row justify="center">
        <v-dialog
          v-model="unavailabilityRecord"
          width="950px"
          @click:outside="handleUnavailabilityRecordClosing"
          @keydown.esc="handleUnavailabilityRecordClosing"
        >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            class="v-card v-sheet theme--light"
          >
            <v-row
              class="pa-6 ma-0 align-center"
              :class="{ 'justify-space-between': editMode }"
            >
              <span class="text-h5">Unavailability Record</span>
              <v-btn
                v-if="editMode"
                class="mx-2 white--text"
                fab
                small
                color="#1976D2"
                @click="deleteUnavailabilityRecord"
                :loading="deletionProcessing"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-row>
            <v-tabs-items v-model="tab" class="px-3">
              <v-tab-item>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        outlined
                        label="Name"
                        :items="employees"
                        :item-text="fullName"
                        return-object
                        v-model="employee"
                        :disabled="editMode"
                        :rules="[rules.requiredObject]"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-menu
                        v-model="unavailabilityDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="unavailabilityDatesRange"
                            label="Date(s) unavailable"
                            prepend-icon="mdi-calendar-remove"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="
                              unavailabilityDatesValidation
                                ? null
                                : dateValidationError
                            "
                            :rules="tab == 0 ? [rules.required] : []"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="unavailabilityDates"
                          range
                          :rules="tab == 0 ? [rules.required] : []"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-combobox
                        ref="comboBox"
                        outlined
                        label="Note"
                        :items="suggestedNotes"
                        v-model="note"
                        :rules="tab == 0 ? [rules.required] : []"
                      ></v-combobox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
            <v-card-actions class="pa-6 pt-4 justify-end">
              <v-btn
                width="30%"
                color="#1976D2"
                class="white--text"
                :disabled="
                  (tab == 0 && !unavailabilityDatesValidation) ||
                  (tab == 1 && !limitedCapacityDateValidation)
                "
                @click="handleUnavailabilityRecord"
                :loading="creationProcessing || updatingProcessing"
              >
                {{ btnTxt }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="defaultCapacity" width="fit-content">
          <v-form
            ref="defaultCapacityForm"
            v-model="defaultCapacityValid"
            lazy-validation
            class="v-card v-sheet theme--light"
          >
            <v-card-title class="justify-space-between py-4">
              <span class="text-h5">Default Workload</span>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      outlined
                      label="Name"
                      :value="fullName(searchEmployee)"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="pb-0">
                    <v-text-field
                      outlined
                      label="LOC Translating Daily Workload"
                      type="number"
                      :readonly="profileView"
                      v-model="localizationDefaultCapacity"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" class="pb-0">
                    <v-text-field
                      outlined
                      label="LOC Editing Daily Workload"
                      type="number"
                      :readonly="profileView"
                      v-model="editingDefaultCapacity"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="d-flex justify-end px-6 py-4">
              <v-btn
                v-if="!profileView"
                width="30%"
                color="secondary"
                @click="handleDefaultCapacityUpdate"
                :loading="confirmationProcessing"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
// vuex
import { mapGetters, mapActions } from "vuex";
// internal
import {
  processEvent,
  getEvents,
  deleteEvent,
  processUser,
  getAllStaff,
  getEnumValues,
  getAllProjects,
  getMultipleUsersWorkload,
  getPostMultipleUsersWorkload,
  getStaffWorkload
} from "@/utils/newDbUtils";
import { publishMessage } from "@/utils/slackUtils";
import { customBreakpoint, timeUnits } from "@/utils/mixins";
import { alphabetColors, managersDesiredColors } from "@/utils/constants";
import { filter } from "lodash";

export default {
  name: "AdminCalendar",
  props: {
    mode: {
      type: Number,
      required: false,
      default: 0,
    },
    employeeToSearch: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    profileView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      personListSnapshot: [],
      projectListSnapshot: [],
      roleListSnapshot: [],
      geoListSnapshot: [],
      workloadOptions: [
        {
          title: "Localization | Primary",
          value: "localizationPrimary",
        },
        {
          title: "Localization | Secondary",
          value: "localizationSecondary",
        },
        {
          title: "Copywriting | Primary",
          value: "copywritingPrimary",
        },
        {
          title: "Copywriting | Secondary",
          value: "copywritingSecondary",
        }
      ],
      workload: "Localization | Primary",
      calendarVariant: "availability",
      workloadView: "week",
      showCalendarLoader: false,
      focus: "",
      focusMenu: false,
      currentDate: {},
      events: [],
      employeesLoading: true,
      employees: [],
      managers: [],
      leadEditors: [],
      admins: [],
      employee: {},
      showPersonList: false,
      personInputFilter: "",
      projectInputFilter: "",
      geoInputFilter: "",
      filterPersons: [],
      showRoleList: false,
      showProjectsList: false,
      roles: ["Admin", "Manager", "Lead Editor", "Staff"],
      showGeosList: false,
      filterRole: "Staff",
      geos: [],
      filterGeo: "",
      geosLoading: true,
      projectsList: [],
      filterProject: null,
      defaultWorkloadProjectName: "iTunes FC",
      valid: true,
      unavailabilityRecord: false,
      unavailabilityDateMenu: false,
      unavailabilityDates: [],
      suggestedNotes: [
        "Time off",
        "At capacity (can't accept new tasks)",
        "Sick/personal day",
        "National holiday",
      ],
      note: null,
      limitedCapacityDateMenu: false,
      limitedCapacityDates: [],
      limitedCapacityNote: null,
      localization: null,
      editing: null,
      tab: 0,
      formMode: ["Unavailability Record"],
      creationProcessing: false,
      editMode: false,
      recordID: null,
      updatingProcessing: false,
      deletionProcessing: false,
      view: 0,
      workloadView: 0,
      mutableMode: this.mode,
      searchEmployee: this.employeeToSearch,
      dataForWriting: [],
      dataForEditing: [],
      defaultCapacity: false,
      defaultCapacityValid: true,
      localizationDefaultCapacity: null,
      editingDefaultCapacity: null,
      confirmationProcessing: false,
      dateValidationError: "End date can't be before start date",
      usersActivityData: {},
      calendarStartDate: null,
      calendarEndDate: null,
      rules: {
        required: (value) => !!value || "Required",
        requiredObject: (value) =>
          (value ? !!Object.keys(value).length : !!value) || "Required",
      },
    };
  },
  methods: {
    ...mapActions("flashMessage", ["handleFlash"]),
    changeCalendarView(view) {
      const isOpeningWorkloadView =
        this.calendarVariant !== "workload" && view === "workload";
      this.calendarVariant = view;
      this.usersActivityData = {};
      if (isOpeningWorkloadView) {
        this.applyWorkloadDefaultFilters();
      }
      console.log("usersActivityData clean", this.usersActivityData);
      this.getUsersData();
    },
    applyWorkloadDefaultFilters() {
      let didChange = false;

      if (this.filterRole !== "Staff") {
        this.filterRole = "Staff";
        didChange = true;
      }

      const defaultProject =
        this.projectsList.find(
          (project) => project.name === this.defaultWorkloadProjectName
        ) || null;

      if (
        defaultProject &&
        (!this.filterProject || this.filterProject.id !== defaultProject.id)
      ) {
        this.filterProject = defaultProject;
        didChange = true;
      }

      if (didChange) {
        this.filterPersons = [];
        this.personListSnapshot = [];
        this.projectListSnapshot = [];
      }
    },
    getWorkloadDataByDate(userLimits) {
      if (this.workload === "Localization | Primary") {
        let limit = userLimits?.localizationPrimary || 0;
        let limitOnDate = userLimits?.localizationPrimaryLimit || 0;
        return { limit, limitOnDate };
      } else if (this.workload === "Localization | Secondary") {
        let limit = userLimits?.localizationSecondary || 0;
        let limitOnDate = userLimits?.localizationSecondaryLimit || 0;
        return { limit, limitOnDate };
      } else if (this.workload === "Copywriting | Primary") {
        let limit = userLimits?.copywritingPrimary || 0;
        let limitOnDate = userLimits?.copywritingPrimaryLimit || 0;
        return { limit, limitOnDate };
      } else if (this.workload === "Copywriting | Secondary") {
        let limit = userLimits?.copywritingSecondary || 0;
        let limitOnDate = userLimits?.copywritingSecondaryLimit || 0;
        return { limit, limitOnDate };
      }
    },
    async changeView(view) {
      this.view = view;
      this.$nextTick(() => {
        this.getUsersData();
      })
    },
    async changeWorkloadView(view) {
      this.workloadView = view;
      this.$nextTick(() => {
        this.getUsersData();
      })
    },
    async getCurrentPage(date) {
      const newPage = {
        month: this.$moment(date.start.month + "", "M").format("M"),
        year: this.$moment(date.start.year + "").format("YYYY"),
      };
      if (JSON.stringify(newPage) !== JSON.stringify(this.currentDate)) {
        this.currentDate = newPage;
        await this.getUsersData();
      }
    },
    clearRoleFilter() {
      this.filterRole = "";
      this.showRoleList = false;
      this.events = [];
      this.getUsersData();
    },
    setRoleFilter(item) {
      this.filterRole = item;
      this.showRoleList = false;
      this.roleListSnapshot = [];
      this.getUsersData();
    },
    setGeoFilter(item) {
      this.filterGeo = item;
      this.showGeosList = false;
      this.geoListSnapshot = [];
      this.filterPersons = [];
      this.personListSnapshot = [];
      this.showPersonList = false;
      this.getUsersData();
    },
    clearGeosFilter() {
      this.filterGeo = "";
      this.showGeosList = false;
      this.events = [];
      this.getUsersData();
    },
    clearPersonsFilter() {
      this.filterPersons = [];
      this.personListSnapshot = [];
      this.showPersonList = false;
      this.events = [];
      this.getUsersData();
    },
    addPersonToFilterList(item) {
      const exists = this.filterPersons.some(p => p.id === item.id);

      if (exists) {
        this.filterPersons = this.filterPersons.filter(p => p.id !== item.id);
      } else {
        this.filterPersons.push(item);
      }

      this.getUsersData();
    },
    setProjectFilter(item) {
      this.filterProject = item;
      this.showProjectsList = false;
      this.filterPersons = [];
      this.personListSnapshot = [];
      this.projectListSnapshot = [];
      this.getUsersData();
    },
    clearProjectFilter() {
      this.filterProject = null;
      this.showProjectsList = false;
      this.projectListSnapshot = [];
      this.events = [];
      this.getUsersData();
    },
    handleClickGeosOutside(event) {
      const dropdown = this.$refs.geoDropdown;
      const roleDropdown = this.$refs.roleDropdown;
      const personDropdown = this.$refs.personDropdown;
      const projectDropdown = this.$refs.projectDropdown;
      if (
        dropdown &&
        !dropdown.contains(event.target) &&
        roleDropdown &&
        !roleDropdown.contains(event.target) &&
        personDropdown &&
        !personDropdown.contains(event.target) &&
        projectDropdown &&
        !projectDropdown.contains(event.target)
      ) {
        this.showGeosList = false;
        this.showRoleList = false;
        this.showPersonList = false;
        this.showProjectsList = false;
      }
    },
    fullName(item) {
      return `${item?.user?.firstName} ${item?.user?.lastName}`;
    },
    findUserColor(user) {
      let userFullName = this.fullName(user);
      let ifUserAManager = managersDesiredColors.find(
        (el) => el.name === userFullName
      );
      if (ifUserAManager) {
        return ifUserAManager.color;
      } else {
        return alphabetColors.find((el) => el.character === user.user?.lastName[0])?.color;
      }
    },
    refreshChecker(date) {
      if (date.month !== this.currentDate.month) {
        this.updateCurrentDate(date.month, date.year);
        // if (!this.mutableMode) this.getCalendarData(); // turned off until the calendar MM/YY query will be ready on backend
      }
    },
    updateCurrentDate(month, year) {
      const newDate = {
        month,
        year,
      };
      this.currentDate = { ...newDate };
    },
    markUnavailable(value) {
      this.refreshChecker({
        month: this.$moment(value.date).format("MM"),
        year: this.$moment(value.date).format("YYYY"),
      });
      this.employee = {};
      this.note =
        this.localization =
        this.editing =
        this.limitedCapacityNote =
          null;
      this.unavailabilityDates = [];
      this.unavailabilityDates.push(value.date);
      this.limitedCapacityDates = [];
      this.unavailabilityRecord = true;
      this.$refs?.form?.resetValidation();
    },
    handleUnavailabilityRecord() {
      if (this.note || this.tab == 0) this.$refs.comboBox.blur();
      if (this.limitedCapacityNote || this.tab == 1)
        this.$refs.limitedCapacityBox.blur();
      setTimeout(() => {
        if (this.$refs.form.validate()) {
          this.creationProcessing = true;
          const data = {
            personName: {
              firstName: this.employee.user.firstName,
              lastName: this.employee.user.lastName,
            },
            startDate:
              this.tab == 0
                ? `${this.unavailabilityDates[0]}T12:00:00`
                : `${this.limitedCapacityDates[0]}T12:00:00`,
            endDate:
              this.tab == 0
                ? this.unavailabilityDates[1]
                  ? `${this.unavailabilityDates[1]}T12:00:00`
                  : `${this.unavailabilityDates[0]}T12:00:00`
                : this.limitedCapacityDates[1]
                ? `${this.limitedCapacityDates[1]}T12:00:00`
                : `${this.limitedCapacityDates[0]}T12:00:00`,
            note: this.tab == 0 ? this.note : this.limitedCapacityNote,
            adjustedDailyLocalization: this.tab == 0 ? 0 : this.localization,
            adjustedDailyEditing: this.tab == 0 ? 0 : this.editing,
          };

          if (this.editMode) Object.assign(data, { id: this.recordID });
          processEvent({ data, staffId: this.employee.user.id }).then(
            (resp) => {
              this.creationProcessing = false;
              if (resp?.status === 200) {
                if (this.tab == 0)
                  publishMessage({
                    user: this.employee.adminDetails.slackIdPm
                      ? `<@${this.employee.adminDetails.slackIdPm}>`
                      : `*${this.employee.user.firstName} ${this.employee.user.lastName}*`,
                    mode: "availability",
                    data: {
                      from: this.unavailabilityDates[0],
                      to: this.unavailabilityDates[1],
                      note: this.note,
                    },
                  });
                this.getUsersData();
                this.handleUnavailabilityRecordClosing();
              }
              this.handleFlash({
                response: resp,
                show: true,
              });
            }
          );
        }
      }, 100);
    },
    handleUnavailabilityRecordClosing() {
      this.unavailabilityRecord =
        this.editMode =
        this.creationProcessing =
          false;
      this.unavailabilityDates = [];
      this.limitedCapacityDates = [];
    },
    editUnavailabilityRecord(record) {
      this.editMode = true;
      console.log("record", record);
      this.employee = this.employees.find(
        (employee) =>
          employee.user.id === this.searchEmployee?.user?.id ||
          (record.event.name.includes(employee.user.firstName) &&
            record.event.name.includes(employee.user.lastName))
      );
      console.log("this.employee", this.employee);
        record.event.start === record.event.end
          ? this.unavailabilityDates.push(record.event.start)
          : this.unavailabilityDates.push(record.event.start, record.event.end);
        this.note = record.event.note;
      this.recordID = record.event.availabilityId;
      this.unavailabilityRecord = true;
    },
    deleteUnavailabilityRecord() {
      this.deletionProcessing = true;
      deleteEvent(this.recordID).then((resp) => {
        this.deletionProcessing = false;
        this.getUsersData();
        this.handleUnavailabilityRecordClosing();
        this.handleFlash({ response: resp, show: true });
      });
    },
    getDatesRange(startDate, endDate) {
      let datesRange = [];
      for (
        let dateVar = new Date(startDate);
        dateVar <= endDate;
        dateVar.setDate(dateVar.getDate() + 1)
      ) {
        datesRange.push(this.$moment(new Date(dateVar)).format("YYYY-MM-DD"));
      }
      return datesRange;
    },
    mergeRecordsByDate(initialArray, operation) {
      initialArray.forEach((el) => {
        const existingItems = this[`dataFor${operation}`].filter((item) => {
          return item[`${operation} Due Date`] === el[`${operation} Due Date`];
        });
        if (existingItems.length) {
          const existingItemIndex = this[`dataFor${operation}`].indexOf(
            existingItems[0]
          );
          this[`dataFor${operation}`][existingItemIndex]["Word Count"] =
            Number(
              this[`dataFor${operation}`][existingItemIndex]["Word Count"]
            ) + el["Word Count"];
        } else {
          this[`dataFor${operation}`].push(el);
        }
      });
    },
    handleEmployeeCheck() {
      if (this.searchEmployee?.user?.id) this.showCalendarLoader = true;
      this.events = [];
      this.dataForWriting = [];
      this.dataForEditing = [];
      if (this.mutableMode) {
      } else this.getUsersData();
    },
    handleDefaultCapacity() {
      this.localizationDefaultCapacity = this.employees.find(
        (el) => el.user.id === this.searchEmployee.user.id
      ).adminDetails.defaultDailyLocalization;
      this.editingDefaultCapacity = this.employees.find(
        (el) => el.user.id === this.searchEmployee.user.id
      ).adminDetails.defaultDailyEditing;
      this.defaultCapacity = true;
    },
    handleDefaultCapacityUpdate() {
      if (this.$refs.defaultCapacityForm.validate()) {
        this.confirmationProcessing = true;
        const data = {
          defaultDailyLocalization: Number(this.localizationDefaultCapacity),
          defaultDailyEditing: Number(this.editingDefaultCapacity),
        };
        processUser({
          data,
          id: this.searchEmployee.user.id,
          defaultCapacity: true,
        }).then((resp) => {
          if (resp?.status === 200) {
            this.handleEmployeesData();
            publishMessage({
              user: this.searchEmployee.adminDetails.slackIdFc
                ? `<@${this.searchEmployee.adminDetails.slackIdFc}>`
                : `*${this.searchEmployee.user.firstName} ${this.searchEmployee.user.lastName}*`,
              mode: "defaultCapacity",
              data: {
                locDefault: this.localizationDefaultCapacity,
                editDefault: this.editingDefaultCapacity,
              },
            });
            this.confirmationProcessing = false;
            this.defaultCapacity = false;
            this.handleFlash({ response: resp, show: true });
          }
        });
      }
    },
    handleEmployeesData() {
      this.employeesLoading = true;
      getAllStaff().then((resp) => {
        this.employees = resp;
        this.managers = this.employees
          .filter((el) => el.user.userRole === "MANAGER");
        this.leadEditors = this.employees
          .filter((el) => el.adminDetails.leadEditor);
        this.admins = this.employees
          .filter((el) => el.user.userRole === "ADMIN");
        this.employeesLoading = false;
        this.getUsersData();
      });
    },
    getProjectsList() {
      getAllProjects().then((resp) => {
        this.projectsList = resp;
        if (this.calendarVariant === "workload") {
          this.applyWorkloadDefaultFilters();
          this.getUsersData();
        }
      });
    },
    getGeos() {
      getEnumValues("geos", "key").then((data) => {
        this.geos = data;
        this.geosLoading = false;
      });
    },
    handleInitialData() {
      if (this.profileView) {
        this.handleEmployeeCheck();
      } else {
        this.handleEmployeesData();
        this.getGeos();
        this.getProjectsList();
      }
    },
    getRoleFilteredEmployees() {
      if (this.filterRole === "Admin") {
        return this.admins;
      }
      if (this.filterRole === "Manager") {
        return this.managers;
      }
      if (this.filterRole === "Lead Editor") {
        return this.leadEditors;
      }

      // Default to all staff for "Staff" and empty role filter.
      return this.employees;
    },
    getFilteredPersonIds() {
      if (this.filterPersons.length > 0) {
        return this.filterPersons.map((el) => el.id);
      }

      let scopedEmployees = this.getRoleFilteredEmployees();

      if (this.filterProject) {
        const projectStaffIds = new Set(
          (this.filterProject.staff || []).map((el) => el.user.id)
        );
        scopedEmployees = scopedEmployees.filter((el) =>
          projectStaffIds.has(el.user.id)
        );
      }

      if (this.filterGeo) {
        scopedEmployees = scopedEmployees.filter((el) =>
          (el.adminDetails?.geos || []).includes(this.filterGeo)
        );
      }

      return [...new Set(scopedEmployees.map((el) => el.user.id))];
    },
    /* handleDropdowns() {
      Promise.all([
        getEnum("GEO"),
        getAllStaff(),
        getAllProjects()
      ])
        .then((resp) => {
          [this.geos, this.employees, this.projectsList] = resp;
          this.managers = this.employees
            .filter((el) => el.user.userRole === "MANAGER")
            .map((el) => `${el.user.firstName} ${el.user.lastName}`);
          this.leadEditors = this.employees
            .filter((el) => el.adminDetails.leadEditor)
            .map((el) => `${el.user.firstName} ${el.user.lastName}`);
          this.admins = this.employees
            .filter((el) => el.user.userRole === "ADMIN")
            .map((el) => `${el.user.firstName} ${el.user.lastName}`);
          this.employeesLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.dropdownsLoading = false;
        });
    }, */
    async getUsersData() {
      this.$nextTick(async () => {
        try {
          this.showCalendarLoader = true;
          const startDate = `${this.$refs.calendar.lastStart.year}-${String(this.$refs.calendar.lastStart.month).padStart(2, '0')}-${String(this.$refs.calendar.lastStart.day).padStart(2, '0')}`;
          const endDate = `${this.$refs.calendar.lastEnd.year}-${String(this.$refs.calendar.lastEnd.month).padStart(2, '0')}-${String(this.$refs.calendar.lastEnd.day).padStart(2, '0')}`;
          const personIds = this.getFilteredPersonIds();
          const shouldUseActiveStaffEndpoint =
            this.filterRole === "Staff" &&
            this.filterPersons.length === 0 &&
            !this.filterProject &&
            !this.filterGeo;
          console.log("startDate", startDate, "endDate", endDate);
          this.calendarStartDate = startDate;
          this.calendarEndDate = endDate;
          console.log("request", { startDate, endDate, size: 50, page: 0, payload: { personIds } });

          if (!shouldUseActiveStaffEndpoint && personIds.length === 0) {
            this.usersActivityData = {};
            this.events = [];
            return;
          }

          let response = null;
          if (shouldUseActiveStaffEndpoint) {
            response = await getStaffWorkload({
              startDate, 
              endDate,
            });
          } else {
            response = await getPostMultipleUsersWorkload({
              startDate, 
              endDate,
              size: 50,
              page: 0,
              role: this.calendarVariant === 'workload' && this.workload.includes("Primary") ? "PRIMARY" : this.calendarVariant === 'workload' && this.workload.includes("Secondary") ? "SECONDARY" : null,
              payload: {
                personIds,
              }
            });
          }
          this.usersActivityData = response.data;
          console.log("this.usersActivityData", this.usersActivityData);
          const userIdsArray = Object.keys(this.usersActivityData);
          this.events = [];
          userIdsArray.forEach(userId => {
            let userEvents = Object.keys(this.usersActivityData[userId]).map((el) => {
                return {
                  availabilityId: this.usersActivityData[userId][el].availabilityId,
                  name: this.employees.find(el => el.user.id === +userId)?.user?.firstName + " " + this.employees.find(el => el.user.id === +userId)?.user?.lastName,
                  start: el,
                  end: el,
                  note: this.usersActivityData[userId][el].unavailableReason,
                  localization: this.usersActivityData[userId][el].copywritingPrimaryLimit - this.usersActivityData[userId][el].copywritingPrimary,
                  editing: this.usersActivityData[userId][el].copywritingSecondaryLimit - this.usersActivityData[userId][el].copywritingSecondary,
                  id: +userId,
                  color:
                    this.usersActivityData[userId][el].unavailableReason === "Time off"
                      ? "#ADE3ED"
                      : this.usersActivityData[userId][el].unavailableReason === "At capacity (can't accept new tasks)"
                      ? "#EBA79B"
                      : this.usersActivityData[userId][el].unavailableReason === "National holiday"
                      ? "#CAF2BF"
                      : this.usersActivityData[userId][el].unavailableReason === "Sick/personal day"
                      ? "#F2E9AE"
                      : "#DBD5D0",
                }
              })
            this.events.push(...userEvents);
          });
          console.log("this.events", this.events);
        } catch(error) {
          console.log(error);
        } finally {
          this.showCalendarLoader = false;
        }
      })
    }
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    workloadOptionsList() {
      return this.workloadOptions.map((option) => option.title);
    },
    dataListforWorkload() {
      if (!this.calendarStartDate || !this.calendarEndDate) return [];

      // Build full visible date range
      const fullDateRange = [];
      const current = this.$moment(this.calendarStartDate);
      const end = this.$moment(this.calendarEndDate);
      while (current.isSameOrBefore(end)) {
        fullDateRange.push(current.format('YYYY-MM-DD'));
        current.add(1, 'day');
      }

      return Object.keys(this.usersActivityData).map(userId => {
        const employee = this.employees.find(el => el.user.id === +userId);
        return {
          name: `${employee?.user?.firstName} ${employee?.user?.lastName}`,
          abreviation: `${employee?.user?.firstName[0]}${employee?.user?.lastName[0]}`,
          color: this.findUserColor(employee),
          id: +userId,
          data: fullDateRange.map(date => ({
            ...(this.usersActivityData[userId][date] || {}),
            date,
          }))
        };
      });
    },
    projectListToShow() {
      if (this.showProjectsList && this.projectListSnapshot.length > 0) {
        if (this.projectInputFilter) {
          return this.projectListSnapshot.filter((el) =>
            el.name.toLowerCase().includes(this.projectInputFilter.toLowerCase())
          );
        }
        return this.projectListSnapshot;
      }

      let newProjectsList = [...this.projectsList];

      if (this.filterProject) {
        const selectedProject = newProjectsList.find(el => el.id === this.filterProject.id);
        const otherProjects = newProjectsList.filter(el => el.id !== this.filterProject.id);
        
        otherProjects.sort((el1, el2) => el1.name.localeCompare(el2.name));
        
        newProjectsList = selectedProject 
          ? [selectedProject, ...otherProjects]
          : otherProjects;
      } else {
        newProjectsList.sort((el1, el2) => el1.name.localeCompare(el2.name));
      }

      if (this.projectInputFilter) {
        newProjectsList = newProjectsList.filter((el) =>
          el.name.toLowerCase().includes(this.projectInputFilter.toLowerCase())
        );
      }

      return newProjectsList;
    },
    rolesListToShow() {
      if (this.showRoleList && this.roleListSnapshot.length > 0) {
        return this.roleListSnapshot;
      }

      let rolesList = [...this.roles];

      if (this.filterRole) {
        const selectedRole = rolesList.find(el => el === this.filterRole);
        const otherRoles = rolesList.filter(el => el !== this.filterRole);
        
        otherRoles.sort((el1, el2) => el1.localeCompare(el2));
        
        rolesList = selectedRole 
          ? [selectedRole, ...otherRoles]
          : otherRoles;
      } else {
        rolesList.sort((el1, el2) => el1.localeCompare(el2));
      }

      return rolesList;
    },
    personsListToShow() {
      if (this.showPersonList && this.personListSnapshot.length > 0) {
        if (this.personInputFilter) {
          return this.personListSnapshot.filter((el) =>
            el.name.toLowerCase().includes(this.personInputFilter.toLowerCase())
          );
        }
        return this.personListSnapshot;
      }

      let personsList = [];
      if (!this.filterRole) {
        personsList = this.employees.map((el) => {
          return {
            name: `${el.user.firstName} ${el.user.lastName}`,
            initials: `${el.user.firstName[0]}${el.user.lastName[0]}`,
            id: el.user.id,
            geos: el.adminDetails.geos,
            color: this.findUserColor(el),
          };
        });
      } else {
        if (this.filterRole === "Admin") {
          personsList = this.admins.map((el) => {
            return {
              name: `${el.user.firstName} ${el.user.lastName}`,
              initials: `${el.user.firstName[0]}${el.user.lastName[0]}`,
              id: el.user.id,
              geos: el.adminDetails.geos,
              color: this.findUserColor(el),
            };
          });
        }
        if (this.filterRole === "Manager") {
          personsList = this.managers.map((el) => {
            return {
              name: `${el.user?.firstName} ${el.user?.lastName}`,
              initials: `${el.user?.firstName[0]}${el.user?.lastName[0]}`,
              id: el.user?.id,
              geos: el.adminDetails.geos,
              color: this.findUserColor(el),
            };
          });
        }
        if (this.filterRole === "Lead Editor") {
          personsList = this.leadEditors.map((el) => {
            return {
              name: `${el.user.firstName} ${el.user.lastName}`,
              initials: `${el.user.firstName[0]}${el.user.lastName[0]}`,
              id: el.user.id,
              geos: el.adminDetails.geos,
              color: this.findUserColor(el),
            };
          });
        }
        if (this.filterRole === "Staff") {
          personsList = this.employees.map((el) => {
            return {
              name: `${el.user.firstName} ${el.user.lastName}`,
              initials: `${el.user.firstName[0]}${el.user.lastName[0]}`,
              id: el.user.id,
              geos: el.adminDetails.geos,
              color: this.findUserColor(el),
            };
          });
        }
      }
      if (this.filterProject) {
        personsList = this.filterProject.staff.map((el) => {
          return {
            name: `${el.user.firstName} ${el.user.lastName}`,
            initials: `${el.user.firstName[0]}${el.user.lastName[0]}`,
            id: el.user.id,
            geos: el.adminDetails.geos,
            color: this.findUserColor(el),
          };
        })
      }
      if (this.filterGeo) {
        personsList = personsList.filter((el) => el.geos.includes(this.filterGeo));
      }
      
      // Sort: selected items first, then alphabetically within each group
      if (this.filterPersons.length > 0) {
        const selectedIds = new Set(this.filterPersons.map(p => p.id));
        
        const selected = personsList.filter(el => selectedIds.has(el.id));
        const unselected = personsList.filter(el => !selectedIds.has(el.id));
        
        selected.sort((el1, el2) => el1.name.localeCompare(el2.name));
        unselected.sort((el1, el2) => el1.name.localeCompare(el2.name));
        
        personsList = [...selected, ...unselected];
      } else {
        personsList.sort((el1, el2) => el1.name.localeCompare(el2.name));
      }
      
      // Apply search filter if needed
      if (this.personInputFilter) {
        personsList = personsList.filter((el) =>
          el.name.toLowerCase().includes(this.personInputFilter.toLowerCase())
        );
      }
      
      return personsList;
    },
    geosListToShow() {
      if (this.showGeosList && this.geoListSnapshot.length > 0) {
        if (this.geoInputFilter) {
          return this.geoListSnapshot.filter((el) =>
            el.toLowerCase().includes(this.geoInputFilter.toLowerCase())
          );
        }
        return this.geoListSnapshot;
      }

      let geosList = [...this.geos];

      if (this.filterGeo) {
        const selectedGeo = geosList.find(el => el === this.filterGeo);
        const otherGeos = geosList.filter(el => el !== this.filterGeo);
        
        otherGeos.sort((el1, el2) => el1.localeCompare(el2));
        
        geosList = selectedGeo 
          ? [selectedGeo, ...otherGeos]
          : otherGeos;
      } else {
        geosList.sort((el1, el2) => el1.localeCompare(el2));
      }

      if (this.geoInputFilter) {
        geosList = geosList.filter((el) =>
          el.toLowerCase().includes(this.geoInputFilter.toLowerCase())
        );
      }

      return geosList;
    },
    calendarTitle() {
      return `${this.$moment(this.currentDate.month, "M").format("MMM")}${
        this.laptop
          ? `'${this.$moment(this.currentDate.year).format("YY")}`
          : ` ${this.$moment(this.currentDate.year).format("YYYY")}`
      }`;
    },
    filteredEvents() {
      let filteredData = [];
      filteredData = this.events.filter((el) => el.note && el.note !== "Weekend");
      console.log("filteredData", filteredData);
      console.log("activityDta", this.usersActivityData);
      return filteredData;
    },
    unavailabilityDatesRange: {
      get: function () {
        return this.unavailabilityDates
          .map((date) => this.formatPickerDate(date))
          .join(" - ");
      },
      set: function (newVal) {
        return (
          this.formatPickerDate(newVal)
            ? [...this.formatPickerDate(newVal)]
            : []
        ).join(" - ");
      },
    },
    unavailabilityDatesValidation() {
      return this.unavailabilityDates[1]
        ? this.$moment(this.unavailabilityDates[0]).isSameOrBefore(
            this.$moment(this.unavailabilityDates[1])
          )
        : true;
    },
    limitedCapacityDatesRange: {
      get: function () {
        return this.limitedCapacityDates
          .map((date) => this.formatPickerDate(date))
          .join(" - ");
      },
      set: function (newVal) {
        return (
          this.formatPickerDate(newVal)
            ? [...this.formatPickerDate(newVal)]
            : []
        ).join(" - ");
      },
    },
    limitedCapacityDateValidation() {
      return this.limitedCapacityDates[1]
        ? this.$moment(this.limitedCapacityDates[0]).isSameOrBefore(
            this.$moment(this.limitedCapacityDates[1])
          )
        : true;
    },
    btnTxt() {
      return this.editMode ? "Update" : "Save";
    },
    viewType() {
      if (this.view === 0) return "month";
      if (this.view === 1) return "week";
      if (this.view === 2) return "day";
    },
    workloadViewType() {
      if (this.workloadView === 0) return "week";
      if (this.workloadView === 1) return "day";
    },
  },
  watch: {
    searchEmployee(newVal) {
      if (newVal === null) {
        this.searchEmployee = {};
        this.mutableMode = 0;
        if (this.mutableMode) this.events = [];
        else this.getUsersData();
      }
      if (newVal?.user?.firstName && newVal?.user?.lastName)
        this.filterRole = this.filterGeo = "";
    },
    showPersonList(isOpen) {
      if (isOpen) {
        this.personListSnapshot = [...this.personsListToShow];
      } else {
        this.personListSnapshot = [];
        this.personInputFilter = "";
      }
    },
    showProjectsList(isOpen) {
      if (isOpen) {
        this.projectListSnapshot = [...this.projectListToShow];
      } else {
        this.projectListSnapshot = [];
        this.projectInputFilter = "";
      }
    },
    showGeosList(isOpen) {
      if (isOpen) {
        this.geoListSnapshot = [...this.geosListToShow];
      } else {
        this.geoListSnapshot = [];
        this.geoInputFilter = "";
      }
    },
    showRoleList(isOpen) {
      if (isOpen) {
        this.roleListSnapshot = [...this.rolesListToShow];
      } else {
        this.roleListSnapshot = [];
      }
    },
    filterRole(newVal) {
      if (newVal) this.searchEmployee = null;
    },
    filterGeo(newVal) {
      if (newVal) this.searchEmployee = null;
    },
    focus(newVal) {
      const date = {
        month: newVal
          ? newVal.split("-")[1]
          : this.$moment(new Date()).format("MM"),
        year: newVal
          ? newVal.split("-")[0]
          : this.$moment(new Date()).format("YYYY"),
      };
      this.refreshChecker(date);
      this.getUsersData();
    },
    workload(newVal) {
      if (newVal) this.getUsersData();
    }
  },
  mixins: [customBreakpoint, timeUnits],
  mounted() {
    this.updateCurrentDate(
      this.$moment(new Date()).format("MM"),
      this.$moment(new Date()).format("YYYY")
    );
    this.handleInitialData();
    document.addEventListener("click", this.handleClickGeosOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickGeosOutside);
  },
};
</script>

<style scoped>
.calendar-filters {
  max-width: 1400px;
  margin: 0 auto;
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px #0000001A;
  border-radius: 10px;
  padding: 0px 16px;
  .calendar-filters--item {
    display: flex;
    align-items: center;
    height: 36px;
    border-radius: 8px;
    border: 1px solid #E0E4EB;
    margin-right: 12px;
    position: relative;
    .calendar-filters--item__title {
      display: flex;
      height: 100%;
      align-items: center;
      border-right: 1px solid #E0E4EB;
      padding: 2px 10px;
      margin-top: 2px;
      cursor: pointer;
      .calendar-filters--item__title--text {
        margin-bottom: 0px;
        font-family: "Inter", sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #525F7A;
        margin-left: 6px;
      }
      .calendar-filters--item__title--icon {
        font-size: 16px;
      }
    }
    .calendar-filters--item__value {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      background-color: #F9FAFB;
      margin-top: 2px;
      cursor: pointer;
      p {
        margin-bottom: 0px;
        font-family: "Inter", sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #000;
        padding: 2px 10px;
      }
      .calendar-filters--item__value__initials {
        width: 24px;
        height: 24px;
        border-radius: 18px;
        padding: 8px 6px 6px 6px;
        font-family: Roboto;
        font-weight: 400;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
        margin-right: 10px;
      }
      .calendar-filters--item__value__name {
        margin-bottom: 0px;
      }
    }
    .calendar-filters--item__remove {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 0 10px;
      font-size: 16px;
      border-left: 1px solid #E0E4EB;
      cursor: pointer;
    }
    .calendar-filters--item__dropdown {
      position: absolute;
      top: 40px;
      left: 0;
      z-index: 120;
      width: 300px;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0px 1px 6px 2px #00000026;
      padding: 10px;
      display: flex;
      flex-direction: column;
      max-height: 400px;
      .dropdown-input--container {
        position: relative;
      }
      .dropdown-input {
        width: 100%;
        height: 36px;
        background-color: #F9FAFB;
        border-radius: 8px;
        border: 1px solid #EDEFF3;
        font-family: "Inter", sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #697A9B;
        padding: 8px 34px 8px 12px;
        margin-bottom: 8px;
        flex-shrink: 0;
      }
      .dropdown-input--clear {
        position: absolute;
        top: 6px;
        right: 8px;
        cursor: pointer;
      }
      .dropdown-input:focus {
        outline: none;
        box-shadow: none;
      }
      .dropdown-list {
        padding-left: 0;
        overflow-y: auto;
        flex-grow: 1;

        .dropdown-list--item {
          display: flex;
          align-items: center;
          padding: 8px 15px;
          cursor: pointer;
          height: 32px;
          border-radius: 4px;
          font-family: "Inter", sans-serif;
          font-weight: 500;
          font-size: 14px;
          color: #697A9B;
          &:hover {
            background-color: #F9FAFB;
          }
        }
        .dropdown-list--item--project {
          height: auto;
          width: 100%;
          .dropdown-list--item__name {
            margin-bottom: 0px;
            width: 90%;
          }
        }
        .dropdown-list--item--geo {
          height: auto;
          width: 100%;
          .dropdown-list--item__name {
            margin-bottom: 0px;
            width: 90%;
          }
        }
        .dropdown-list--item--role {
          height: auto;
          width: 100%;
          .dropdown-list--item__name {
            margin-bottom: 0px;
            width: 90%;
          }
        }
        .dropdown-list--item-person {
          display: flex;
          align-items: center;
          padding: 0px;
          width: 100%;
          margin-bottom: 8px;
          .dropdown-list--item__initials {
            width: 24px;
            max-width: 20%;
            height: 24px;
            border-radius: 18px;
            padding: 8px 6px 6px 6px;
            font-family: Roboto;
            font-weight: 400;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #FFFFFF;
            margin-right: 10px;
          }
          .dropdown-list--item__name {
            margin-bottom: 0px;
            width: 70%;
          }
          .dropdown-list--item__icon {
            width: 10%;
          }
        }
      }
    }
  }
}

.calendar {
  max-width: 1400px;
  margin: 0 auto;
}

.filter {
  width: 120px;
}

.person-picker {
  max-width: 260px;
}

.admin-calendar.disabled {
  pointer-events: none;
}

.admin-calendar >>> .v-calendar-weekly__week {
  min-height: 100px !important;
}

.admin-calendar >>> .v-calendar-weekly__day-label {
  margin-bottom: 5px;
}

.admin-calendar >>> .v-event {
  color: #000 !important;
  line-height: 1.2;
}

.admin-calendar
  >>> .v-btn.v-btn--fab.v-btn--has-bg.v-btn--round.theme--light.v-size--small.transparent {
  background-color: #fff !important;
  color: #3fa198;
}

.admin-calendar
  >>> .v-btn.v-btn--fab.v-btn--has-bg.v-btn--round.theme--light.v-size--small {
  background-color: #ee7975;
}

.workload-calendar__calendar >>> .v-calendar-daily__head {
  margin-right: 0px !important;
}

.workload-calendar__calendar >>> .theme--light.v-calendar-daily {
  border-left: none !important;
}

.workload-calendar__calendar >>> .v-calendar-daily__intervals-head {
  display: none !important;
}

.control {
  width: 100%;
  display:flex;
  padding: 12px 30px;
  .control__month {
    display: flex;
    align-items: center;
    .current-page {
      font-family: Roboto;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      letter-spacing: 0px;
      margin-bottom: 0;
    }
    .control-icon {
      font-size: 24px;
    }
  }
  .control__jumpTo {
    display: flex;
    align-items: center;
    .control__jumpTo--text {
      font-family: 'Roboto';
      font-weight: 500;
      color: #525F7A;
      font-size: 16px;
      line-height: 16px;
      letter-spacing: 0px;
      margin: 0 10px;
    }
    .control__jumpTo--btn {
      width: 100px;
      height: 32px;
      padding: 4px 3px 2.5px 3px;
      border-radius: 8px;
      border: 2px solid #525F7A;
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0px;
      text-align: center;
      cursor: pointer;
      outline: none;
      color: #525F7A;
      margin-right: 10px;
      transition: all 0.2s ease-in-out;
    }
    .control__jumpTo--btn:hover {
      background-color: #525F7A;
      color: #fff;
    }
  }
  .control__calendarView {
    display: flex;
    align-items: center;
    padding: 0 10px;
    border-right: 1px solid #C8C8C8;
    margin-top: auto;
    margin-bottom: auto;
    height: 32px;
    .control__calendarView--text {
      font-family: 'Roboto';
      font-weight: 500;
      color: #525F7A;
      font-size: 16px;
      line-height: 16px;
      letter-spacing: 0px;
      margin-right: 10px;
      margin-bottom: 0px;
    }
    .control__calendarView--btn {
      height: 32px;
      padding: 5px 10px 4px 10px;
      border-radius: 8px;
      color: #525F7A;
      border: 2px solid #525F7A;
      font-family: 'Roboto';
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.89%;
      text-align: center;
      cursor: pointer;
      outline: none;
      transition: all 0.2s ease-in-out;
    }
    .control__calendarView--btn:nth-child(2) {
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      margin-right: 2px;
    }
    .control__calendarView--btn:nth-child(3) {
      border-radius: 0px;
    }
    .control__calendarView--btn:last-child {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      margin-left: 2px;
    }
    .control__calendarView--btn:hover {
      background-color: #525F7A;
      color: #fff;
    }
    .control__calendarView--btn--active {
      background-color: #525F7A;
      color: #fff;
    }
  }
  .control__toggler {
    padding: 0 10px;
    border-right: 1px solid #C8C8C8;
    border-left: 1px solid #C8C8C8;
    margin-top: auto;
    margin-bottom: auto;
    height: 32px;
    .control__toggler--btn {
      width: 100px;
      height: 32px;
      padding: 4px 3px 2.5px 3px;
      border-radius: 8px;
      color: #525F7A;
      border: 2px solid #525F7A;
      font-family: 'Roboto';
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.89%;
      text-align: center;
      cursor: pointer;
      outline: none;
      transition: all 0.2s ease-in-out;
    }
    .control__toggler--btn--active {
      background-color: #525F7A;
      color: #fff;
    }
    .control__toggler--btn:first-child {
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      margin-right: 2px;
    }
    .control__toggler--btn:last-child {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .control__toggler--btn:hover {
      background-color: #525F7A;
      color: #fff;
    }
  }
}

.workload-calendar {
  width: 100%;
  .workload-calendar__data {
    width: 100%;
    padding: 0 !important;
    list-style-type: none;
    .workload-calendar__data--item {
      width: 100%;
      display: flex;
      height: 78px;
      .workload-calendar__data--item__title {
        display: flex;
        align-items: center;
        width: 20%;
        .abreviation {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: "Roboto", sans-serif;
          font-weight: 400;
          font-size: 16px;
          margin-right: 10px;
          margin-left: 10px;
          color: #fff;
        }
        .name {
          font-family: "Roboto", sans-serif;
          font-weight: 400;
          font-size: 16px;
          line-height: 100%;
          letter-spacing: 0.89%;
          color: #525F7A;
        }
      }
      .workload-calendar__data--item__table {
        width: 80%;
        display: flex;
        .table--item {
          border-right: #e0e0e0 1px solid;
          border-bottom: #e0e0e0 1px solid;
        }
        .table--item:first-child {
          border-left: #e0e0e0 1px solid;
        }
      }
    }
  }
  .workload-calendar__calendar {
    width: 80%;
    margin-left: auto;
  }
}

.workload-calendar__empty {
  z-index: 100;
  height: 100px;
  text-align: center;
  position: absolute;
  padding: 35px;
  width: 100%;
  background-color: #fff;
}

.custom-day {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .custom-day__empty {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #D6E6FF;
    margin: auto;
    cursor: pointer;
  }
  .custom-day__checkmark {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #0266E3;
    margin: auto;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .custom-day__exclamation {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #FF7676;
    margin: auto;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
  .custom-day__close {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #D5D5D5;
    margin: auto;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .custom-day__dot {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #D6E6FF;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .custom-day__dot--inner {
      background-color: #0266E3;
      min-width: 5px;
      min-height: 5px;
      border-radius: 50%;
    }
  }
}

.control__left--workload {
  padding: 0 10px;
  border-right: 1px solid #C8C8C8;
  margin-top: auto;
  margin-bottom: auto;
  position: relative;
  label {
    position: absolute;
    top: -2px;
    left: 20px;
    font-size: 10px;
    color: #fff;
  }
  .control__left--workload--select {
    width: 253px;
    height: 32px;
    padding-top: 10px; 
    padding-right: 10px;
    padding-left: 10px;
    border-radius: 6px;
    background-color: #525F7A;
    color: #FFFFFF;
    box-shadow: 0px 2px 4px 0px #00000026;
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
    line-height: 10px;
    letter-spacing: 0%;
    cursor: pointer;
    outline: none;
    overflow: hidden;
  }
}

.font-size--18px {
  font-size: 18px !important;
}
</style>
